







































































import Vue from "vue";
import Component from "vue-class-component";
import TabBar from "@/components/TabBar.vue";
import { api, copyToClipboard, getParams } from "@/api";
import ArticleCard from "@/components/ArticalCard.vue";
import wx from "wx-jssdk-ts";
import { Toast } from "vant";

@Component({
  components: { ArticleCard, TabBar },
})
export default class Withdraw extends Vue {
  protected loading: boolean = false;
  protected lists: any[] = [];
  protected finished: boolean = true;

  protected total: number = 0; // 总数
  protected form: any = {
    nickname: null,
    status: "未打款",
    page: 0,
  };
  protected selectFrom: any;
  protected verifyOptions: any[] = [
    { name: "未打款", value: 0 },
    { name: "拒绝", value: 2 },
    { name: "已打款", value: 1 },
  ];
  protected showWithdrawStatusChoice: boolean = false;
  protected showButton = true;

  public async mounted() {}

  public async search() {
    this.selectFrom = {
      nickname: this.form.nickname,
      status: this.getStatusValue(this.form.status),
      page: this.form.page ? this.form.page : 1,
    };

    this.showButton = true;
    if (this.form.status != "未打款") {
      this.showButton = false;
    }

    await this.reload();
  }

  public selectStatus(item: any) {
    this.showWithdrawStatusChoice = false;

    this.form.status = item.name;
  }

  public async onLoad() {
    this.selectFrom.page++;
    const resp = await api.getWithdrawRecord(this.selectFrom);
    this.loading = false;
    if (!resp.data.length) {
      this.finished = true;
    } else {
      this.lists.push(...resp.data);
    }
    this.total = resp.last_page;
  }

  public async reload() {
    this.selectFrom.page = 0;
    this.lists = [];
    this.loading = true;
    this.finished = false;
    await this.onLoad();
  }

  public getStatusName(status: number) {
    const data = this.verifyOptions.find((value) => {
      return value.value == status;
    });

    return data.name;
  }

  public getStatusValue(name: string) {
    const data = this.verifyOptions.find((value) => {
      return value.name == name;
    });

    return data.value;
  }

  public async verifySuccess(id: number) {
    await api.verifyWithdraw({
      id,
      status: 1,
    });

    await this.reload();
  }

  public async verifyError(id: number) {
    await api.verifyWithdraw({
      id,
      status: 2,
    });

    await this.reload();
  }
}
